import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SSEState<T = unknown> {
  data: T | null;
  error: string | null;
  isConnected: boolean;
}

const initialState: SSEState = {
  data: null,
  error: null,
  isConnected: false,
};

const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<unknown>) => {
      state.data = action.payload;
      state.isConnected = true;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnected = false;
    },
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
  },
});

export const { setData, setError, setConnectionStatus } = sseSlice.actions;
export default sseSlice.reducer;
